import { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, animate } from "framer-motion";

// Animates a numeric value up when scrolled into view.
// Non-numeric values (e.g. "Same-day") are rendered as-is.
export function AnimatedCounter({ value, className = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    const [display, setDisplay] = useState(value);
    const mv = useMotionValue(0);

    const match = String(value).match(/^([^\d]*)(\d[\d,]*)(.*)$/s);

    useEffect(() => {
        if (!match || !inView) return;
        const [, prefix, numStr, suffix] = match;
        const target = parseInt(numStr.replace(/,/g, ""), 10);
        const controls = animate(mv, target, {
            duration: 1.4,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (v) => setDisplay(`${prefix}${Math.round(v)}${suffix}`),
        });
        return controls.stop;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView]);

    return (
        <span ref={ref} className={className}>
            {match ? display : value}
        </span>
    );
}
